import { Card, CardContent } from '@/components/ui/card';
import filterIcon from '@/v2/assets/images/select-filter-icon.png';
import SelectFilterInfoCard from './SelectFilterInfoCard';
export default function MrtServicesExplanation() {
  const imageUrl = filterIcon; // fallback only
  return (
    <div className="flex justify-center mt-4">
      <div className="w-full md:w-3/5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left side */}
          <SelectFilterInfoCard />

          {/* Right side */}
          <Card className="bg-blue-50 border-0 shadow-none rounded-2xl">
            <CardContent className="p-6">
              <h3 className="text-xl font-semibold text-blue-900 mb-4">
                1,5T ar 3T MRT - ką pasirinkti?
              </h3>
              <p className="text-gray-700 mb-2">
                <span className="font-semibold text-blue-700">1,5T ir 3T</span>{' '}
                žymi magnetinio lauko stiprumą.
              </p>
              <p className="text-gray-700 mb-2">
                <span className="font-semibold text-blue-700">1,5T</span> tinka
                daugeliui tiriamųjų sričių ir yra dažniau suderinamas su
                turimais implantais.
              </p>
              <p className="text-gray-700 mb-4">
                <span className="font-semibold text-blue-700">3T</span> pasižymi
                didesne raiška, rekomenduojama tiriant smulkias struktūras.
                Jautresnis turimiems implantams.
              </p>
              <p className="text-sm italic text-blue-600">
                Jei siuntime nenurodytas MRT stiprumas, rinkitės pagal Jums
                patogiausią laiką.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
